import { render, staticRenderFns } from "./ManageServiceOrderRating.vue?vue&type=template&id=02710cf9&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceOrderRating.vue?vue&type=style&index=0&id=02710cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02710cf9",
  null
  
)

export default component.exports